export function addToArray (arr: readonly any[], elem: any): any[] {
  if (arr.includes(elem)) {
    return [...arr]
  } else {
    return [...arr, elem]
  }
}

export function removeFromArray<Type> (arr: readonly Type[], elem: Type): Type[] {
  return arr.filter(function (e: any) { return e !== elem })
}
